import React from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
  Box,
} from "@mui/material";
import gainIcon from "../../../../styles/images/gain_icon.svg";
import lossIcon from "../../../../styles/images/loss_icon.svg";
import { localStorageInstance } from "../../../../utils/storage";

const borderStyle = {
  borderLeft: "1px solid rgba(224, 224, 224, 1)",
  borderRight: "1px solid rgba(224, 224, 224, 1)",
};

export default function SeasonTable({ data }) {
  const emptyRow = {
    player_name: "-",
    rank: "-",
    weekly_gain_loss: "-",
    season_score: "-",
    days: [
      { day: "MON", daily_gain_loss: "-", stocks: [] },
      { day: "TUE", daily_gain_loss: "-", stocks: [] },
      { day: "WED", daily_gain_loss: "-", stocks: [] },
      { day: "THU", daily_gain_loss: "-", stocks: [] },
      { day: "FRI", daily_gain_loss: "-", stocks: [] },
    ],
  };

  // If no players data, show one empty row
  const playersToRender = data.players.length > 0 ? data.players : [emptyRow];

  let currentUserId = localStorageInstance.getItem("user_id")
  console.log("retriving current user == ", data.players.find(player => player.user_id === currentUserId)?.rank)

  const myRank = data.players.find(player => player.user_id === currentUserId)?.rank
  return (
    <Box className="season_table_cont">
      {/* Header / Title */}
      <Box sx={{ mb: 2 }}>
        <Typography variant="h6">
          Week {data.week} - {data.theme}
          <span className="theme-rank">{`${myRank ? 'My Rank #' + myRank : ""}`}</span>
        </Typography>
      </Box>

      <TableContainer component={Paper} sx={{ maxWidth: "100%" }}>
        <Table size="small">
          <TableHead>
            <TableRow sx={{ backgroundColor: "#f9f9f9" }}>
              <TableCell sx={{ fontWeight: "bold", ...borderStyle }}>
                Rank
              </TableCell>
              <TableCell sx={{ fontWeight: "bold", ...borderStyle }}>
                Player
              </TableCell>
              {/* Create a column for each day in the data */}
              {["MON", "TUE", "WED", "THU", "FRI"].map((day) => (
                <TableCell
                  key={day}
                  sx={{ fontWeight: "bold", ...borderStyle }}
                >
                  {day}
                </TableCell>
              ))}
              <TableCell sx={{ fontWeight: "bold", ...borderStyle }}>
                Total
              </TableCell>
              <TableCell sx={{ fontWeight: "bold", ...borderStyle }}>
                Score
              </TableCell>
              <TableCell sx={{ fontWeight: "bold", ...borderStyle }}>
                Season Score
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {playersToRender.map((player) => (
              <TableRow key={player.player_name}>
                <TableCell sx={{ ...borderStyle }}>
                  <Typography variant="body2" fontWeight="bold">
                    {player.rank}
                  </Typography>
                </TableCell>
                <TableCell sx={{ ...borderStyle }}>
                  <Typography variant="body2" fontWeight="bold">
                    {player.player_name}
                  </Typography>
                </TableCell>
                {player.days
                  ? // Regular row with data
                  player.days.map((day) => (
                    <TableCell
                      key={day.day}
                      sx={{
                        verticalAlign: "top",
                        ...borderStyle,
                        padding: "0px !important",
                      }}
                    >
                      <div className="stock-cell">
                        {day.stocks.map((stock, index) =>
                          stock.stock ? (
                            <div key={index} className="stock-item">
                              <span className="stock-name">
                                {stock.stock}
                              </span>
                              <span className={`stock-value ${stock.trend}`}>
                                {stock.daily_gain_loss}
                              </span>
                              {stock?.daily_gain_loss && (
                                <img
                                  src={
                                    stock?.daily_gain_loss?.startsWith("-")
                                      ? lossIcon
                                      : gainIcon
                                  }
                                />
                              )}
                            </div>
                          ) : (
                            ""
                          )
                        )}
                        {day.daily_gain_loss !== "" && <div className="stock-item-result ">
                          <span className={`stock-value`}>
                            {day.daily_gain_loss}
                          </span>
                          <img
                            src={
                              day?.daily_gain_loss?.startsWith("-")
                                ? lossIcon
                                : gainIcon
                            }
                          />
                        </div>}
                      </div>
                    </TableCell>
                  ))
                  : // Empty cells for days
                  ["MON", "TUE", "WED", "THU", "FRI"].map((day) => (
                    <TableCell sx={{ ...borderStyle }} key={day}>
                      -
                    </TableCell>
                  ))
                }
                <TableCell
                  sx={{
                    color: player?.weekly_gain_loss?.startsWith("-")
                      ? "red"
                      : player.weekly_gain_loss === "-"
                        ? "inherit"
                        : "green",
                    fontWeight: "bold",
                    ...borderStyle,
                  }}
                >
                  {player.weekly_gain_loss}
                </TableCell>

                <TableCell sx={{ fontWeight: "bold", ...borderStyle }}>
                  {player.win_or_loss ? '1' : '0'}
                </TableCell>
                <TableCell sx={{ fontWeight: "bold", ...borderStyle }}>
                  {player?.season_score === null ? "---" : player?.season_score}
                </TableCell>
              </TableRow >
            ))}
          </TableBody >
        </Table >
      </TableContainer >
    </Box >
  );
}
